import React from "react";
import { Chip } from "@heroui/react";

interface TagSelectorProps {
  tags: any;
  selectedTags: string[];
  handleTagClick: (tag: string) => void;
}

const TagSelector: React.FC<TagSelectorProps> = ({
  tags,
  selectedTags,
  handleTagClick,
}) => {
  // Create a set to store unique tags
  const uniqueTags = new Set(Object.values(tags));

  return (
    <div className="flex flex-wrap gap-2">
      {[...uniqueTags].sort().map((tag: any) => (
        <Chip
          key={tag}
          color="default"
          onClick={() => handleTagClick(tag)}
          classNames={{
            base: selectedTags.includes(tag)
              ? "h-fit min-w-fit cursor-pointer rounded-full border border-moss-primary bg-moss-primary px-2 text-white"
              : "h-fit min-w-fit cursor-pointer rounded-full border border-moss-primary bg-white px-2 text-moss-primary",
            content: "p-0 font-medium",
          }}
        >
          {tag}
        </Chip>
      ))}
    </div>
  );
};

export default TagSelector;
